import { axiosBuySell, axiosLocal5000Local } from "../axios";

export async function getHistoricalReturn(username:any ,selectedIdentifiers:any ,selectedDate:any){
    return await axiosLocal5000Local.post(`/liveOverall/get_historical_days_return`,{
        "username" : username,
        "selectedIdentifiers" : selectedIdentifiers,
        "selectedDate": selectedDate})
    .then((res:any)=>{
        return res?.data
    }).catch((error:any)=>{
        console.log("Exception occured while fetching NIFTY50 Spot charts data : ", error)
        return {"error": true}
    })
}

export async function getReleaseNote(version:any)
{
    return await axiosBuySell.post(`/generalise_api/releaseNote`,{"version":version})
    .then((res:any)=>{
        return res.data;
    }).catch((e:any)=>console.log(e))
}

export async function getWordCloudImage(){
    return await axiosBuySell.post(`/word-cloud/get_word_cloud_image`).then((res:any) =>{
        return res?.data;
    }).catch((error:any) => {
        console.log("Exception occured while fetching the word cloud image :", error)
    })
}


export async function getStockDailyData(date:any, symbol:string){
    return await axiosBuySell.post(`/word-cloud/stock_daily_data`,{"selectedDate":date,"symbol":symbol})
    .then((res:any)=>{
        return res;
    }).catch((error:any)=>{
        console.log("Error in getStockDailyData: ", error);
        return {'error':true};
    })
}

export async function getStockSignals(date:any){
    return await axiosBuySell.post(`/word-cloud/stock_signals`,{"date":date})
    .then((res:any)=>{
        return res;
    }).catch((error:any)=>{
        console.log("Error in getStockSignals: ", error);
        return {'error':true};
    })
}
export async function getEquityDetails(date:any, username:string){
    return await axiosBuySell.post(`/word-cloud/equity_details`,{"selectedDate":date,"username":username})
    .then((res:any)=>{
        return res;
    }).catch((e:any)=>{
        console.log("Error in getEquityDetails:", e);
        return{'error':true};
    })
}

export async function getPrivilegedCodeAndSymbol(){
    return await axiosBuySell.post(`word-cloud/equity_code_symbol`)
    .then((res:any)=> {return res})
    .catch((e:any)=>{
        console.log("Error in getEquityDetails:", e);
        return{'error':true};
    })
}

export async function getPrivilegedCodeAndSymbolBank(){
    return await axiosBuySell.post(`word-cloud/equity_code_symbol_bank`)
    .then((res:any)=> {return res})
    .catch((e:any)=>{
        console.log("Error in getEquityDetails:", e);
        return{'error':true};
    })
}

export async function getTradeReason(date:string,symbol:string,time:string){
    return await axiosBuySell.post(`word-cloud/trade_reason`,{date:date,symbol:symbol,time:time})
    .then((res:any)=> {
        if(res?.data.length>0) return res?.data[0];
        else return {};
    })
    .catch((e:any)=>{
        console.log("Error in getEquityDetails:", e);
        return {};
    })
    
}

export async function getLiveChartData(date:string){
    return await axiosBuySell.post(`liveoverall/getLiveSentiment`,{date:date})
    .then((res:any)=> {
        if(res?.data.length>0) return res?.data[0];
        else return {};
    })
    .catch((e:any)=>{
        console.log("Error in getLiveChartData:", e);
        return {};
    })
}

export async function saveColumnOrder(colOrder:any, mail: String, type:any){
    return await axiosBuySell.post(`generalise_api/setColOrder`,{
        order:colOrder, mail: mail, type:type
    })
    .then((res:any)=> {
        return res
    })
    .catch((e:any)=>{
        console.log("Error in setting column order:", e);
        return {};
    })
}

export async function getColumnOrder(mail : String){
    return await axiosBuySell.post(`generalise_api/getColOrder`, {mail: mail})
    .then((res:any)=> {
        if(res?.data.length>0) return res?.data[0];
        else return {};
    })
    .catch((e:any)=>{
        console.log("Error in get Column Order:", e);
        return {};
    })
}
